import { clearSessionCache, confirmFreshSession } from "~/lib/auth-guard";

type NavigateAfterConfirmation = () => void | Promise<void>;

export async function confirmLoginSessionAndNavigate(
  navigateAfterConfirmation: NavigateAfterConfirmation,
) {
  clearSessionCache();
  const freshSession = await confirmFreshSession();

  if (!freshSession?.user) {
    return false;
  }

  await navigateAfterConfirmation();
  return true;
}
